import React, {FC}              from "react";
import {HBox}                   from "@sirius/ui-lib/src/blocks/Layout";
import {RowType}                from "./@types";
import {Separator}              from "./Separator";
import {block}                  from "./block";
import {getCellStyle}           from "./getCellStyle";

export const Row:FC<RowType> = ({
    checked,
    index,
    cols,
    row,
    colOffset,
    toggleRowChecked,
    RowEditElement,
    hardWidthDisabled,
    RowClassByRow,
    SeparatorElement,
    isLast,
    wrapperRef,
    closeEditOnScroll
}) =>
    <React.Fragment >
        <Separator
            colSpan          = {cols.length}
            SeparatorElement = {SeparatorElement}
            index            = {index}
        />
        <tr
            className={
                block.el('tbody-row') +
                block.el('tbody-row').bod('checked', checked ) +
                (RowClassByRow ? RowClassByRow(row,index) : '')
            }
        >
            {
                cols.map(
                    ({
                         DataCell,
                         column
                     },
                     ci
                    ) =>
                        <td
                            key = {`${index}-${ci}`}
                            className = {
                                block.el('tbody-cell') +
                                block.el('tbody-cell').mod(`name-${column.name}`) +
                                block.el('tbody-cell').bod('checked', checked ) +
                                block.el('tbody-cell').bod('sticky', !!column.sticky) +
                                block.el('tbody-cols-cell').bod('sticky-last', column.sticky && !cols[ci + 1]?.column.sticky )
                            }
                            style = {
                                getCellStyle(
                                    column,
                                    colOffset[ci],
                                    colOffset[ci + 1] - colOffset[ci],
                                    hardWidthDisabled
                                )
                            }
                        >
                            <HBox className={block.el('tbody-cell-wrapper')}>
                                {
                                    column.name === 'edit' && !RowEditElement
                                        ? null
                                        : <DataCell
                                            checked           = {checked}
                                            RowEditElement    = {RowEditElement}
                                            toggleRowChecked  = {toggleRowChecked}
                                            column            = {column}
                                            row               = {row}
                                            data              = {column.name in row ? row[column.name] : null}
                                            wrapperRef        = {wrapperRef}
                                            closeEditOnScroll = {closeEditOnScroll}
                                        />
                                }
                            </HBox>
                        </td>
                )
            }
        </tr>
        {
            isLast &&
            <Separator
                colSpan          = {cols.length}
                SeparatorElement = {SeparatorElement}
                index            = {index + 1}
            />
        }
    </React.Fragment>
;
